module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAnUlEQVRoQ+2ZQQqAMAwEzf8fHfEeD8t2kch4bksyO42gdS1/ann9Fw18nSAJ/DKB7u6psao6nvjxA5/CaUDwkgQmWCiEQgIBFDJhMYVQCIVMAihkAmQKoRAKmQRQyATIFEIhFDIJoJAJMDKFzJqk7TQg4QosjiTAlzkhKRLgPSDoMv71MfeP29df4gSUtzMjl5gGBAIkIMCKLF2fwA2mbIQx6bFkgwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/iexplore/components/browser/static/1.png
// module id = 1051
// module chunks = 2